// Map ISO-3166 alpha-2 → display name as it appears in src/libs/countries.js.
// Used to translate Cloudflare CF-IPCountry header into the dropdown's value.
// Covers EU + 40 most common non-EU countries we expect customers from.

const ISO_TO_COUNTRY = {
    // EU 27
    AT: "Austria",     BE: "Belgium",    BG: "Bulgaria",   HR: "Croatia",
    CY: "Cyprus",      CZ: "Czechia",    DK: "Denmark",    EE: "Estonia",
    FI: "Finland",     FR: "France",     DE: "Germany",    GR: "Greece",
    HU: "Hungary",     IE: "Ireland",    IT: "Italy",      LV: "Latvia",
    LT: "Lithuania",   LU: "Luxembourg", MT: "Malta",      NL: "Netherlands (the)",
    PL: "Poland",      PT: "Portugal",   RO: "Romania",    SK: "Slovakia",
    SI: "Slovenia",    ES: "Spain",      SE: "Sweden",
    // Common non-EU (matching countries.js spelling)
    GB: "United Kingdom",
    US: "United States of America (the)",
    CA: "Canada",       AU: "Australia",   NZ: "New Zealand",
    CH: "Switzerland",  NO: "Norway",      IS: "Iceland",
    UA: "Ukraine",      RU: "Russian Federation (the)",
    TR: "Turkey",       IL: "Israel",      AE: "United Arab Emirates (the)",
    SA: "Saudi Arabia", EG: "Egypt",       ZA: "South Africa",
    BR: "Brazil",       MX: "Mexico",      AR: "Argentina",   CL: "Chile",
    CO: "Colombia",     PE: "Peru",
    JP: "Japan",        KR: "Korea (the Republic of)",
    CN: "China",        HK: "Hong Kong",   TW: "Taiwan (Province of China)",
    SG: "Singapore",    MY: "Malaysia",    TH: "Thailand",    VN: "Viet Nam",
    PH: "Philippines (the)", ID: "Indonesia",
    IN: "India",        PK: "Pakistan",    BD: "Bangladesh",
    NG: "Nigeria",      KE: "Kenya",       MA: "Morocco",
    RS: "Serbia",       AL: "Albania",     MK: "Republic of North Macedonia",
    BA: "Bosnia and Herzegovina", ME: "Montenegro", XK: null, // Kosovo not in ISO-3166
};

export default ISO_TO_COUNTRY;

export function countryByIso(code) {
    if (!code) return null;
    return ISO_TO_COUNTRY[String(code).toUpperCase()] || null;
}
